import { EERROR_BUTTON_EVENT, IError, IErrorComponentData } from '@app/core/models/error.model';
import { createAction, props } from '@ngrx/store';
import { ErrorsType } from './error.state';

export const handleError = createAction(
  '[Error] Handle Error',
  props<{
    message?: string;
    errorType?: ErrorsType;
    isCustomer?: boolean;
    callback?: Function;
    componentData?: IErrorComponentData;
  }>()
);

export const showError = createAction(
  '[Error] Show Error',
  props<{
    message: string;
    errorType: ErrorsType;
    isCustomer?: boolean;
    callback?: Function;
    componentData?: IErrorComponentData;
  }>()
);

export const showErrorComponent = createAction(
  '[Error] Show Error Component',
  props<{
    errorComponentData: IErrorComponentData;
  }>()
);

export const clearError = createAction('[Error] Clear Error');

export const controlErrorButtonEvent = createAction(
  '[Error Component] Control Error Button Event',
  props<{ buttonEvent: EERROR_BUTTON_EVENT }>()
);
